import * as Sentry from "@sentry/react";
Sentry.init({
    dsn: "https://795473bf04ddc32bcd27bca88698aa8c@o4509202381471744.ingest.de.sentry.io/4509202595643473",
    environment: getEnvironment(),
});
import { Router } from './components/Router';
// Controllers
import { BaseController } from './controllers/BaseController';
import { PagesController } from './controllers/PagesController';
import { CarsController } from './controllers/CarsController';
import getEnvironment from "./utils/get-environment";
const router = new Router();
router.register({
    Base: BaseController,
    Pages: PagesController,
    Cars: CarsController,
});
if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", () => {
        router.run();
    });
}
else {
    router.run();
}
